export const getTodos = state => state.todos
export const getError = state => state.error